var Handlebars = require("/home/admin/gitlab_code/enhancer/project-center-assets/node_modules/handlebars/runtime.js");
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper;

  return "<iframe class=\"delivery-management\"\n	style=\"width: 1024px; border: none; height: 100%; overflow: auto\"\n	src=\""
    + container.escapeExpression(((helper = (helper = helpers.deliveryUrl || (depth0 != null ? depth0.deliveryUrl : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"deliveryUrl","hash":{},"data":data}) : helper)))
    + "\">\n</iframe>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/deliveryManagement.html
// module id = 36
// module chunks = 0